<template>
  <div>
    <main>
      <section class="hero-image">
        <div class="hero-title"><h1>Timelapse <br>film production</h1></div>
      </section>
    </main>
  </div>
</template>

<script>
  export default {
    name: 'home'
  }
</script>

<style lang="scss" scoped>

  @import '../assets/scss/_variables';
  @import '../assets/scss/_include-media';

  header {
    color: $color-primary;
  }
  
  main {
    .hero-image{
      position: relative;
      min-height: 100vh;
      background-image: url('../assets/images/home-image.jpg');
      background-size: cover;
      background-position: center center;
      background-repeat: no-repeat;
      .hero-title{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        text-align: center;
        z-index: 1;
        line-height: 1;
        h1 {
          position: relative;
          top: 50%;
          transform: perspective(1px) translateY(-50%);
          color: $color-primary;
          @include media('>small') {
            font-size: 10rem;
          }
          @include media('>2000px') {
            font-size: 15rem;
          }          
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/home.vue